import { render, staticRenderFns } from "./AnonymousFaq.vue?vue&type=template&id=d20495bc&"
import script from "./AnonymousFaq.vue?vue&type=script&lang=js&"
export * from "./AnonymousFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports